<input type="checkbox" class="cm-checkbox" [id]="id" (click)="onInputClick()" [checked]="value" [disabled]="disabled">
<label class="cm-checkbox-label" [for]="id" [ngClass]="{required: required}" (click)="onLabelClick($event)">
  <ng-content></ng-content>
</label>
